<template>
    <v-container style="padding-top: 80px">
        <Sidebar :validaFilter="validaFilter" @realizarB="realizarB" @guardaB="guardaB"
            :selectedOption="selectedOption" />
        <div v-if="showHelpDialog">
            <LideresHelpDialog @dialogCloseEvent="helpDialogEmit"></LideresHelpDialog>
        </div>
        <v-card class="pb-0 mb-5" style="border-left: 0.25rem solid var(--v-anchor-base) !important;">
            <v-card-title class="pa-5 pb-3">
                <v-row>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="10" style="display: grid; place-items: center;">
                        <p style="color: var(--v-anchor-base);" class="title-text-style text-center">Líderes De Primera
                            Atención</p>
                    </v-col>
                    <v-col cols="12" md="1" style="display: grid; place-items: center;">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" fab dark small v-bind="attrs" v-on="on"
                                    @click="Notificaciones()">
                                    <v-icon size="20" :color="'#FFFFFF'"> mdi-comment </v-icon>
                                </v-btn>
                            </template>
                            <span>Notificaciones</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-card-title>
        </v-card>
        <v-card class="pt-1 pb-0" elevation="5">
            <!--  <v-card-title> -->
            <v-container>
                <v-row align="center" justify="center" v-if="permisoEsLider">
                    <v-col cols="12" md="12">
                        <v-progress-linear buffer-value="100" value="100" :color="firmar ? '#4CAF50' : 'blue-grey'"
                            height="30">
                            <template>
                                <strong style="color:white">{{ this.EtiquetaLider }}</strong>
                            </template>
                        </v-progress-linear>
                    </v-col>
                </v-row>

                <v-row align="center" justify="center">
                    <v-col cols="12" md="1" style="display: grid; place-items: center;">
                        <v-switch v-model="firmar" inset @change="isSwitchChange = true" color="primary"
                            v-if="permisoEsLider">
                        </v-switch>
                    </v-col>
                    <v-col cols="12" md="10" style="display: grid; place-items: center;" v-if="mostrarBotones">
                        <v-btn-toggle v-model="selectedOption" color="primary" rounded mandatory>
                            <v-btn elevation="2" large outlined rounded> Usuario </v-btn>
                            <v-btn elevation="2" large outlined rounded> Sin Asignación </v-btn>
                            <v-btn elevation="2" large outlined rounded> Todos </v-btn>
                        </v-btn-toggle>
                    </v-col>
                    <v-col cols="12" md="1" style="display: grid; place-items: center;">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn fab dark small v-bind="attrs" v-on="on" @click="helpDialog()" color="primary">
                                    <v-icon size="20" color="white">
                                        mdi-help-circle-outline
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Ayuda</span>
                        </v-tooltip>
                    </v-col>
                </v-row>

            </v-container>
            <!-- </v-card-title> -->
            <v-container v-if="opcSelected == true">
                <DataTableLideres :url="urlListado" :columns="columns" :params="displayInputs" :order="[]"
                    @apiDT="apiDT = $event" :formatterActions="formatterActions" :rowStyle="style" class="tablaLideres">
                </DataTableLideres>
            </v-container>
            <v-dialog transition="dialog-top-transition" persistent max-width="600" v-model="saltarValider">
                <v-card>
                    <v-toolbar color="primary" dark>Saltar Candado de Valider</v-toolbar>
                    <v-card-text>
                        <label style="font-style: italic; color:darkred">Para saltar el valider es necesario
                            ingresar su firma electrónica</label>
                        <br />
                        <label> Firma electrónica: </label>
                        <br />
                        <v-text-field id="firma" ref="input" v-model="firma" autocomplete="off" maxlength="17"
                            style="-webkit-text-security: disc;" autofocus solo
                            v-on:blur="firma = firma != null ? firma.trim() : null"></v-text-field>
                        <span v-if="errorFirma" id="revfirmaelectronica" style="font-style: italic; color: red">{{
                            messageFirma }}</span>
                        <br />
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn @click="CerrarModal()">Cerrar</v-btn>
                        <v-btn @click="ValidarFirma()" color="primary" :loading="loading"
                            :disabled="loading">Aceptar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import Lideres from "@/services/Lideres/Lideres.service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';
import DataTableLideres from "@/components/pages/DataTableNet/DataTable";
import LideresHelpDialog from "@/components/pages/Lideres/components/LideresHelpDialog";
import Sidebar from '@/components/pages/Lideres/Sidebar.vue';

export default {
    title() {
        return this.$route.meta.title
    },
    components: { DataTableLideres, LideresHelpDialog, Sidebar },
    data() {
        return {
            selectedItemfilter: 0,
            itemsFiltros: [],
            permisoLideres: false,
            permisoSaltarValider: false,
            style: 'Lideres',
            InitialData: null,
            selectedOption: 4,
            opcSelected: false,
            showHelpDialog: false,
            bodyItems: [],
            lideresBodyInfo: [],
            displayInputs: {
                opc: undefined,
                filter: 0,

                aseguradora: '',
                estado: '',
                localidad: '',
                relevancia: '',
                asistencia: '',
                usuario: '',
                conductor: '',
                arribo: '',
                termino: '',
                vhdetenido: '',
                pendiwhats: '',
            },
            urlListado: "Lideres/obtenerTablaLideresMain",
            columns: [
                { name: "twhNotificacionPendiente", data: "twhNotificacionPendiente", title: "", orderable: false, formatter: [this, "formatearWH"], },
                { name: "Nrreportei", data: "Nrreportei", title: "Reporte", orderable: false, formatter: [this, "formatearReporte"], },
                { name: "Prnombre", data: "Prnombre", title: "Proveedor", orderable: false, },
                { name: "Svfhreporte", data: "Svfhreporte", title: "Fecha Reporte", orderable: false, },
                { name: "Svfhturnado", data: "FechaTurnado", title: "Turnado", orderable: false, formatter: [this, "formatearTurnado"], },
                { name: "Spaajfhllamajustador", data: "stAjustador", title: "LLm. AJ", orderable: false, formatter: [this, "formatearLlamadaAjus"], },
                { name: "Spaasfhllamasegurado", data: "stCliente", title: "Llm. NA/NC", orderable: false, formatter: [this, "formatearLlamadaNANC"], },
                { name: "Spaabfhllamabogado", data: "stAbogado", title: "Llm. AB", orderable: false, formatter: [this, "formatearLlamadaAbog"], },
                { name: "ColorArribo", data: "ColorArribo", title: "Arribo", orderable: false, formatter: [this, "formatearArribo"], },
                { name: "svfhtermino", data: "svfhtermino", title: "Termino", orderable: false, },
                { name: "Valider", data: "ColorValider", title: "Valider", formatter: [this, "formatearValider"], orderable: false, },
                { name: "tiempoVida", data: "TiempoVida", title: "Tiempo de Vida", formatter: [this, "formatearTiempoVida"], orderable: false, },
                { name: "Lider", data: "Lduslogin", title: "Líder", formatter: [this, "mostrarLider"], orderable: false, },
                { name: "Asistencia", data: "Asistencia", title: "Asistencia", orderable: false, },
                { name: "Aseguradora", data: "Clnombrecorto", title: "Aseguradora", orderable: false, },
                { name: "Localidad", data: "Lonombre", title: "Localidad", orderable: false, },
                { name: "ConductorDeteneido", data: "tiempodetcond", title: "Tiempo Cond. Det.", orderable: false, },
                { name: "filtertext", data: "filtertext", title: "Seguimiento", orderable: false, formatter: [this, "formatearFiltroLideres"], },
            ],

            //LLEVA EL ORDEN DE EL data-action del formmatter
            formatterActions: [
                { click: [this, "ReasignarLider"] },
                { click: [this, "LlamadaAjustador"] },
                { click: [this, "BuscarReporte"] },
                { click: [this, "IrValider"] },
                { click: [this, "LlamadaNA"] },
                { click: [this, "LlamadaAB"] },
            ],
            permisoReasignarLider: false,
            permisoEsLider: false,
            firmar: false,
            EtiquetaLider: 'Líder sin firmar',
            isSwitchChange: false,
            progress: 50,
            auxvalor: 0,
            saltarValider: false,
            firma: '',
            messageFirma: '',
            errorFirma: false,
            loading: false,
            reporteAux: {
                nrreporte: 0,
                svindice: 0,
                aiclave: 0,
                svfhconclusion: null,
            },
            mostrarBotones: false,
            validaFilter: false
        };
    },
    computed: {
        ...mapState(["domain", "informationPage"]),
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '40').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 40)//Permiso para ver concluidos
                        this.permisoLideres = true;
                });
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '154,148,49').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 154)//Permiso para saltar valider
                        this.permisoSaltarValider = true;
                    if (permiso.peclave == 148)//Permiso para reasignar lider
                        this.permisoReasignarLider = true;
                    if (permiso.peclave == 49)//Permiso del lider de primera atencion
                        this.permisoEsLider = true;
                });
            }
        });

        let opcLider = await MetodosGenerales.obtenerSessionReporte('LiderPantalla');
        if (opcLider != null) {
            this.selectedOption = opcLider.opc;
        } else {
            this.selectedOption = this.permisoEsLider == true ? 0 : 2
        }
        let response = await Lideres.ObtenerEstatusLider();
        this.firmar = response.ldestatus == 0 ? false : true;
        this.validaFilter = true;
        await Lideres.obtenerFiltros(this);
        // document.addEventListener('visibilitychange', this.visibilitychange);
        // this.startReloadTimer();


    },
    methods: {
        guardaB(filter) {
            this.displayInputs.filter = filter.filter;
            this.displayInputs.aseguradora = filter.aseguradora;
            this.displayInputs.estado = filter.estado;
            this.displayInputs.localidad = filter.localidad;
            this.displayInputs.relevancia = filter.relevancia;
            this.displayInputs.asistencia = filter.asistencia;
            this.displayInputs.usuario = filter.usuario;
            this.displayInputs.conductor = filter.conductor;
            this.displayInputs.arribo = filter.arribo;
            this.displayInputs.termino = filter.termino;
            this.displayInputs.vhdetenido = filter.vhdetenido;
            this.displayInputs.pendiwhats = filter.pendiwhats;
        },
        realizarB(filter) {
            this.opcSelected = false;
            this.mostrarBotones = false;
            this.displayInputs.filter = filter.filter;
            this.displayInputs.aseguradora = filter.aseguradora;
            this.displayInputs.estado = filter.estado;
            this.displayInputs.localidad = filter.localidad;
            this.displayInputs.relevancia = filter.relevancia;
            this.displayInputs.asistencia = filter.asistencia;
            this.displayInputs.usuario = filter.usuario;
            this.displayInputs.conductor = filter.conductor;
            this.displayInputs.arribo = filter.arribo;
            this.displayInputs.termino = filter.termino;
            this.displayInputs.vhdetenido = filter.vhdetenido;
            this.displayInputs.pendiwhats = filter.pendiwhats;


            this.reloadTable();

            setTimeout(() => {
                this.opcSelected = true;
                this.mostrarBotones = true;
            }, 500);


        },
        helpDialog() {
            this.showHelpDialog = true;
        },
        helpDialogEmit(value) {
            this.showHelpDialog = value;
        },
        formatearWH(datos) {
            if (datos.twhNotificacionPendiente == 1) {
                return `<div style=" display:grid; place-items: center"><div><i aria-hidden="true" class="v-icon notranslate mdi mdi-whatsapp" style="color: #4CAF50" title="Whatsapp Pendiente"></i></div></div>`;
            } else {
                return ``;
            }
        },
        formatearReporte(datos) {
            if ((datos.Aiclave == 1 || datos.Aiclave == 23 || datos.Aiclave == 24 || datos.Aiclave == 5)) {
                return `<div ><button type="button" class="mr-1 dt-formatterAction" aria-haspopup="true" data-action="2" data-params="${datos}" aria-expanded="false"><span class='reporteindice'>${datos.Nrreportei}</span></button></div>`;
            } else {
                return `<span>${datos.Nrreportei}</span>`;
            }
        },
        mostrarLider(datos) {
            if (this.permisoReasignarLider) {
                return `<div style="display:grid; place-items: center;">${datos.Lduslogin}<button type="button" class="v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small indigo dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos.Lduslogin}" title="Reasignar Lider" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-swap-horizontal"></i></span></button></div>`;
            } else {
                return `<div>${datos.Lduslogin}</div>`;
            }
        },
        formatearTurnado(datos) {
            if (datos.TurnadoColor == 'red') {
                return `<div style=" display:grid; place-items: center"><div><i aria-hidden="true" class="v-icon notranslate mdi mdi-checkbox-blank-circle" style="color: ${datos.IconoTurnado}"></i></div><div style="color:${datos.TurnadoColor}">${datos.FechaTurnado}</div></div>`;
            } else {
                return `<div style=" display:grid; place-items: center"><div><i aria-hidden="true" class="v-icon notranslate mdi mdi-checkbox-blank-circle" style="color: ${datos.IconoTurnado}"></i></div><div>${datos.FechaTurnado}</div></div>`;
            }
        },
        formatearFiltroLideres(datos) {
            return `<div><button type="button" disabled class="ml-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small  dt-formatterAction" aria-haspopup="true"  data-action="0" data-params="${datos.filtertext}" title="${datos.filtertext}" aria-expanded="false" style="background-color: ${datos.filtercolor};"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate"></i></span></button></div>`;

            //return `<div><button type="button" class="ml-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small ${datos.ColorLlamadaAjus} dt-formatterAction" aria-haspopup="true" data-action="1" data-params="${datos.stAjustador}" title="${datos.Spaajfhllamajustador}" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-phone"></i></span></button></div>`;
        },
        formatearLlamadaAjus(datos) {
            return `<div><button type="button" class="ml-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small ${datos.ColorLlamadaAjus} dt-formatterAction" aria-haspopup="true" data-action="1" data-params="${datos.stAjustador}" title="${datos.Spaajfhllamajustador}" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-phone"></i></span></button></div>`;
        },
        formatearLlamadaNANC(datos) {
            return `<div><button type="button" class="ml-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small ${datos.ColorLlamadaNANC} dt-formatterAction" aria-haspopup="true" data-action="4" data-params="${datos.stCliente}" title="${datos.Spaasfhllamasegurado}" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-phone"></i></span></button></div>`;
        },
        formatearLlamadaAbog(datos) {
            return `<div><button type="button" class="ml-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small ${datos.ColorLlamadaAbo} dt-formatterAction" aria-haspopup="true" data-action="5" data-params="${datos.stAbogado}" title="${datos.Spaabfhllamabogado}" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-phone"></i></span></button></div>`;
        },
        formatearArribo(datos) {
            return `<div><button type="button" disabled class="ml-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small ${datos.ColorArribo} dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos.stAbogado}" title="${datos.Spaabfhllamabogado}" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi ${datos.IconoArribo}"></i></span></button></div>`;
        },
        formatearValider(datos) {
            if (this.permisoSaltarValider && datos.IconoValider == 'mdi-minus-circle') {
                return `<div><button type="button" class="ml-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small blue dt-formatterAction" aria-haspopup="true" data-action="3" data-params="${datos.IconoValider}" title="Valider" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi ${datos.IconoValider}"></i></span></button></div>`;
            } else if (this.permisoSaltarValider == false && datos.IconoValider == 'mdi-minus-circle') {
                return `<div><button disabled type="button" class="ml-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small grey dt-formatterAction" aria-haspopup="true" data-action="3" data-params="${datos.IconoValider}" title="Valider" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi ${datos.IconoValider}"></i></span></button></div>`;
            }
            else {
                return `<div><button type="button" class="ml-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small ${datos.ColorValider} dt-formatterAction" aria-haspopup="true" data-action="3" data-params="${datos.IconoValider}" title="Valider" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi ${datos.IconoValider}"></i></span></button></div>`;
            }
        },
        formatearTiempoVida(datos) {
            if (datos.ColorTiempoVida == 'red') {
                return `<div style=" display:grid; place-items: center; color:${datos.ColorTiempoVida}">${datos.TiempoVida}</div>`;
            } else {
                return `<div style="display:grid; place-items: center;">${datos.TiempoVida}</div>`;
            }
        },
        async ReasignarLider(params, datos) {
            let lider = {
                nrreporte: datos.Nrreporte,
                svindice: datos.Svindice,
                Lduslogin: datos.Lduslogin
            };
            // this.stopReloadTimer();
            //document.removeEventListener('visibilitychange', this.visibilitychange);
            await MetodosGenerales.guardarEnSesionInfoReporte(lider, 'lider');
            this.$router.push({ name: `ReasignacionLideres` }).catch(error => error);

        },
        async LlamadaAjustador(params, item, fila) {
            let reporte = {
                nrreporte: item.Nrreporte,
                svindice: item.Svindice,
                aiclave: item.Aiclave,
                svfhconclusion: item.svfhconclusion
            };
            //this.stopReloadTimer();
            // document.removeEventListener('visibilitychange', this.visibilitychange);
            await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');

            this.$router.push({ name: `${"PantallaAjustador"}` }).catch(error => error);
        },
        async LlamadaNA(params, item, fila) {
            let reporte = {
                nrreporte: item.Nrreporte,
                svindice: item.Svindice,
                aiclave: item.Aiclave,
                svfhconclusion: item.svfhconclusion
            };
            // this.stopReloadTimer();
            //document.removeEventListener('visibilitychange', this.visibilitychange);
            await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
            this.$router.push({ name: `${"PantallaNA"}` }).catch(error => error);
        },
        async LlamadaAB(params, item, fila) {
            let reporte = {
                nrreporte: item.Nrreporte,
                svindice: item.Svindice,
                aiclave: item.Aiclave,
                svfhconclusion: item.svfhconclusion
            };

            await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
            //this.stopReloadTimer();
            //document.removeEventListener('visibilitychange', this.visibilitychange);
            this.$router.push({ name: `${"PantallaAB"}` }).catch(error => error);
        },
        /*  visibilitychange() {
             if (document.visibilityState === 'visible') {
                 this.startReloadTimer();
             } else {
                 this.stopReloadTimer();
             }
         }, */
        /* startReloadTimer() {
            console.log('empezar')
            // Iniciar un temporizador para recargar la página cada 5 minutos (300,000 milisegundos)
            this.reloadTimer = setInterval(() => {
                location.reload(); // Recargar la página*
            }, 300000);
        }, */
        /* stopReloadTimer() {
            console.log('entro a stopReloadTimer y se detuvo')

            // Detener el temporizador si está en ejecución
            if (this.reloadTimer) {
                clearInterval(this.reloadTimer);
                this.reloadTimer = null;
            }
        }, */
        Notificaciones() {
            this.$router.push({ name: `Notificaciones` }).catch(error => error);
        },
        async BuscarReporte(params, item, fila) {
            let reporte = {
                nrreporte: item.Nrreporte,
                svindice: item.Svindice,
                aiclave: item.Aiclave,
                svfhconclusion: item.svfhconclusion
            };
            var ver = 0;
            let formData = new FormData();
            formData.append("nrreporte", item.Nrreporte);
            formData.append("svindice", item.Svindice);
            formData.append("uslogin", MetodosGenerales.ObtenerUserName());
            await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                ver = data;
            });

            if (ver == 0) {
                this.$router.push({ name: `${"DatosIncompletos"}` }).catch(error => error);
            }
            else {
                //this.stopReloadTimer();
                //document.removeEventListener('visibilitychange', this.visibilitychange);
                await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                let url = this.$router.resolve({ name: `${"Asistencias"}` });
                window.open(url.href, '_blank');
            }
        },
        async firmarLider() {
            if (this.isSwitchChange) {
                let ldestatus = this.firmar == true ? 1 : 0;
                await Lideres.ActivarLideres(ldestatus);
            }
        },
        async IrValider(params, item, fila) {
            if (item.IconoValider == 'mdi-minus-circle') {
                this.saltarValider = true;
                this.reporteAux.nrreporte = item.Nrreporte;
                this.reporteAux.svindice = item.Svindice;
                this.reporteAux.aiclave = item.Aiclave;
                this.reporteAux.svfhconclusion = item.svfhconclusion;
            } else {
                let valider = {
                    nrreporte: item.Nrreporte,
                    svindice: item.Svindice,
                    aiclave: item.Aiclave,
                    svfhconclusion: item.svfhconclusion
                };
                //this.stopReloadTimer();
                //document.removeEventListener('visibilitychange', this.visibilitychange);
                await MetodosGenerales.guardarEnSesionInfoReporte(valider, 'valider');
                this.$router.push({ name: `AgregarMovimientoValider` }).catch(error => error);;
            }
        },
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        CerrarModal() {
            this.saltarValider = false;
            this.firma = '';
            this.messageFirma = '';
        },
        async ValidarFirma() {
            let val = await Lideres.valFirmaElectronica(this.reporteAux, this.firma, 'LIBERA CANDADO DEL VALIDER EN LIDERES');
            if (val == 0) {
                this.messageFirma = 'Firma electrónica incorrecta';
                this.errorFirma = true;
            } else {
                let response = await Lideres.SaltarValider(this.reporteAux);
                if (response) {
                    this.$swal({
                        position: 'center',
                        icon: 'success',
                        title: 'Éxito',
                        text: 'Se ha liberado el candado del valider.',
                        showConfirmButton: true,
                        confirmButtonColor: '#536DFE',
                        confirmButtonText: 'Aceptar',
                        allowOutsideClick: false,
                        timer: 3000
                    }).then(async () => {
                        let valider = {
                            nrreporte: this.reporteAux.nrreporte,
                            svindice: this.reporteAux.svindice,
                            aiclave: this.reporteAux.aiclave,
                            svfhconclusion: this.reporteAux.svfhconclusion
                        };
                        //this.saltarValider = false
                        await MetodosGenerales.guardarEnSesionInfoReporte(valider, 'valider');
                        this.$router.push({ name: `AgregarMovimientoValider` }).catch(error => error);
                    });

                } else {
                    this.$swal({
                        position: 'center',
                        icon: 'error',
                        title: 'Error',
                        text: 'Ocurrió un error al liberado el candado del valider, por favor inténtelo nuevo.',
                        showConfirmButton: true,
                        confirmButtonColor: '#536DFE',
                        confirmButtonText: 'Aceptar',
                        allowOutsideClick: false,
                        timer: 3000
                    })
                }
            }
        }
    },
    beforeDestroy() {
        //console.log("beforeDestroy")
        //this.stopReloadTimer();
        //document.removeEventListener('visibilitychange', this.visibilitychange);

    },
    watch: {
        async selectedOption(newvalue) {
            if (newvalue == 0) {
                this.displayInputs.usuario = '';
            }
            let opcLider = {
                opc: newvalue,
            };
            await MetodosGenerales.guardarEnSesionInfoReporte(opcLider, 'LiderPantalla');
            this.opcSelected = false;
            this.displayInputs.opc = newvalue;
            this.reloadTable();
            this.opcSelected = true;
            this.mostrarBotones = true;
        },
        async 'firmar'(val) {
            this.EtiquetaLider = val == true ? 'Líder firmado' : 'Líder sin firmar'
            this.firmarLider();
        },
        async 'firma'(val) {
            if (val == null || val == '') {
                this.errorFirma = true;
                this.messageFirma = 'Campo requerido';
            }
            else {
                if (val.length < 8 || val.length > 16) {
                    this.errorFirma = true;
                    this.messageFirma = 'Firma electrónica avanzada debe tener un mínimo de 8 y menor a 17 carácteres';
                }
                else {
                    this.errorFirma = false;
                }
            }
        },
    },
};
</script>

<style>
.header-cell-stlye {
    padding-left: 2px !important;
    padding-right: 2px !important;
    width: 5% !important;
}

.marcador-rojo-style {
    height: 20px !important;
    width: 10px !important;
    background-color: red !important;
    color: red !important;
}

.iteams-body-style {
    background-color: rgb(15, 216, 243) !important;
    padding-left: 2px !important;
    padding-right: 2px !important;
}

.header-text-style {
    font-family: Poppins, sans-serif;
    font-size: 14px !important;
    font-weight: 900 !important;
}
</style>

<style scoped>
.notification-header-style {
    background-color: rgb(26, 6, 206);
}

.test-card-style {
    background-color: red;
}

.title-text-style {
    font-family: Poppins, sans-serif;
    font-size: 32px !important;
    font-weight: bold !important;
}

.sub-title-text-style {
    font-family: Poppins, sans-serif;
    font-size: 14px !important;
    font-weight: bold !important;
}
</style>
